import { Injectable } from '@angular/core';

import { IsAlreadyLoggedInGuardActions } from '@elio/emanager-front/auth/action';
import { UserSelectors } from '@elio/emanager-front/auth/state';
import { isErrorState } from '@elio/shared/models';
import { filterStatusLoadedOrInError } from '@elio/shared/rxjs-utils';
import { LoggerService } from '@elio/shared/tools/logger';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, Observable, of, timeout } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IsAlreadyLoggedInGuard {
  private TIMEOUT_USER_LOADING = 10000;

  constructor(
    private store: Store,
    private logger: LoggerService
  ) {}

  canMatch() {
    this.store.dispatch(IsAlreadyLoggedInGuardActions.loadUser());
    return this.waitUserIsLoaded().pipe(
      map((isLoggedIn: boolean) => !isLoggedIn),
      catchError(() => {
        this.logger.error(`Request timed out after: ${this.TIMEOUT_USER_LOADING}ms`);
        return of(true);
      })
    );
  }

  private waitUserIsLoaded(): Observable<boolean> {
    return this.store.select(UserSelectors.getUserCallState).pipe(
      timeout(this.TIMEOUT_USER_LOADING),
      filterStatusLoadedOrInError(), // wait for user to be loaded (in case of page refresh)
      mergeMap((loadingState) => (isErrorState(loadingState) ? of(false) : this.store.select(UserSelectors.isLoggedIn)))
    );
  }
}
